import enConstant from './labels/enConstants'
const strings = {
    ...enConstant
  };
  
  export default strings;